import { DepartmentModelConstants } from '@/utils/constants/department.model.constants'
import { ProfileModelConstants } from '@/utils/constants/profile.model.constants'
import { useUserStore } from '@/stores/userStore'

interface UserData {
  name: string
  photo: string
  profile: [
    {
      id: number
      name: string
    },
  ]
  regionalId?: string
}
export const useUserData = () => {
  const store = useUserStore()
  const userData = store.userData as UserData

  const getFullName = () => {
    return userData?.name ?? ''
  }

  const getPhoto = () => {
    if (userData?.photo)
      return `${import.meta.env.VITE_AVATAR_BASE_URL}/${userData.photo}`

    return ''
  }

  const getProfile = () => {
    return userData?.profile?.[0] ?? { id: 0, name: '' }
  }

  const isSuperAdmin = () => {
    return (
      getProfile().id.toString() ===
      ProfileModelConstants.SUPERADMIN_ID.ID.toString()
    )
  }

  const isAdmin = () => {
    return (
      getProfile().id.toString() ===
      ProfileModelConstants.ADMIN_ID.ID.toString()
    )
  }

  const isAdminRegional = () => {
    return (
      getProfile().id.toString() ===
      ProfileModelConstants.ADMIN_REGIONAL_ID.ID.toString()
    )
  }

  const getRegional = () => {
    if (!userData?.regionalId) return DepartmentModelConstants.DN.ID.toString()
    return userData.regionalId
  }

  return {
    getFullName,
    getPhoto,
    getProfile,
    isSuperAdmin,
    isAdmin,
    isAdminRegional,
    getRegional,
  }
}
